export const VERTICAL_INSET_PER_ENV = {
  fo: {
    s: 84,
    m: 84,
    l: 128,
    xl: 128,
  },
  po: {
    s: 85,
    m: 120,
    l: 120,
    xl: 120,
  },
  bo: {
    s: 76,
    m: 76,
    l: 76,
    xl: 76,
  },
};

export const VERTICAL_INSET_PER_MOBILE_APP_ENV = {
  fo: {
    ...VERTICAL_INSET_PER_ENV.fo,
    s: 0,
  },
  po: {
    ...VERTICAL_INSET_PER_ENV.po,
    s: 0,
  },
  bo: {
    ...VERTICAL_INSET_PER_ENV.bo,
    s: 0,
  },
};
